import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';

const OrderSuccess = () => {
  const location = useLocation();
  const orderId = location.state?.orderId;

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4">
      <div className="max-w-md w-full text-center">
        <div className="bg-white rounded-lg shadow-md p-8">
          <CheckCircle className="w-20 h-20 text-green-500 mx-auto mb-6" />

          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            Đặt Hàng Thành Công!
          </h1>

          <p className="text-gray-600 mb-6">
            Cảm ơn bạn đã đặt hàng. Chúng tôi sẽ liên hệ sớm để xác nhận thông tin giao hàng.
          </p>

          {orderId && (
            <div className="bg-gray-50 rounded-lg p-4 mb-6">
              <p className="text-sm text-gray-600 mb-1">Mã Đơn Hàng</p>
              <p className="font-mono font-semibold text-primary-600">{orderId}</p>
            </div>
          )}

          <div className="space-y-3">
            <Link
              to="/orders"
              className="block w-full bg-primary-600 text-white py-3 rounded-lg font-semibold hover:bg-primary-700 transition"
            >
              Xem Đơn Hàng
            </Link>

            <Link
              to="/products"
              className="block w-full border border-primary-600 text-primary-600 py-3 rounded-lg font-semibold hover:bg-primary-50 transition"
            >
              Tiếp Tục Mua Sắm
            </Link>
          </div>

          <div className="mt-6 pt-6 border-t">
            <p className="text-sm text-gray-600">
              Bạn sẽ nhận được cuộc gọi từ nhóm của chúng tôi để xác nhận đơn hàng và địa chỉ giao hàng.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderSuccess;
